<template>
  <b-card class="card-content px-2 py-1" no-body border-variant="light">
    <!-- <b-card-header class="card-header-content">
      <h5 class="mb-0 text-center text-white">
        <slot name="title"></slot>
      </h5>
    </b-card-header> -->
    <div v-if="items.length > 0" class="card-items">
      <b-list-group
        v-for="item in items"
        :key="item.name"
        horizontal
        class="d-flex flex-column justify-content-left"
        :style="{'cursor': item.url ? 'pointer' :'not-allowed'}"
      >
        <b-list-group-item class="card-item active" :disabled="!item.url" @click="$emit('openLink', item)" style="width: auto;">
          <div class="card-item-text">
            <p class="pr-1 m-0"> {{item.name}}</p>
            <p v-if="item.description" class="card-item-description pr-1 m-0">
              {{ item.description }}
            </p>
          </div>
          <div class="card-corner" href="#">
            <div class="go-corner-icon">
              <font-awesome-icon v-if="item.type == 'file'" :icon="['far', 'file-alt']" size="sm"/>
              <font-awesome-icon v-else :icon="['fas', 'link']" size="sm"/>
            </div>
          </div>
        </b-list-group-item>
      </b-list-group>
    </div>
    <div v-else>
      <b-list-group>
        <b-list-group-item class="card-item inactive" disabled style="width: auto;">
          <p class="pr-1 m-0 text-danger">No se encontraron resultados</p>
          <div class="card-corner">
          </div>
        </b-list-group-item>
      </b-list-group>
    </div>
  </b-card>
</template>

<script>
export default {
  name: 'ResourceCard',
  props: {
    items: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .list-group:nth-child(1) {
    margin-top: 0.8rem;
  }
  .card-content {
    display: flex;
    border-radius: 2rem;
    flex-direction: column;
    height: 100%;
  }
  .card-items {
    flex: 1 1 auto;
    overflow: auto;
    min-height: 0;
    max-height: calc(100vh - 400px);
  }
  .card-header-content {
    border-radius: 0.5rem;
    background-color:#163D7D;
    margin: 10px;
    flex-shrink: 0;
  }
  .card-item {
    margin-bottom: 0.5rem;
    padding-left: 0.625rem;
    color: black;
    display: block;
    top: 0px;
    position: relative;
    background-color: #f5f5f5;
    border-radius: 8px;
    text-decoration: none;
    z-index: 0;
    overflow: hidden;
    border: 1px solid #f2f8f9;
    &.inactive {
      border: 1px solid red;
    }

    &:hover {
      box-shadow: 0px 4px 8px rgba(38, 38, 38, 0.2);
      top: -4px;
      color: #163D7D;
      border: 1px solid #cccccc;
    }

    &:before {
      content: "";
      position: absolute;
      z-index: -1;
      top: -16px;
      right: -16px;
      background: #00838d;
      height: 32px;
      width: 32px;
      border-radius: 32px;
      transform: scale(2);
      transform-origin: 50% 50%;
      transition: transform 0.15s ease-out;
    }

    &:hover:before {
      transform: scale(2.15);
    }

  }

  .card-item-text {
    padding-right: 32px;
  }

  .card-item-description {
    font-size: 0.875rem;
    color: #6c757d;
    line-height: 1.3;
    margin-top: 2px !important;
  }

  .card-item:hover .card-item-description {
    color: #4a6da8;
  }

  .card-corner {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    width: 32px;
    height: 32px;
    overflow: hidden;
    top: 0;
    right: 0;
    background-color: #163D7D;
    border-radius: 0 4px 0 32px;
  }

  .go-corner-icon {
    margin-top: -4px;
    margin-right: -4px;
    color: white;
    font-family: courier, sans;
  }
</style>
